document.addEventListener('DOMContentLoaded', function () {
  var price = document.getElementById('Price');
  var compare = document.getElementById('Compare');
  var save = document.getElementById('Save');
  document.querySelectorAll('.variant-picker input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (price) price.textContent = radio.dataset.price;
      if (compare) compare.textContent = radio.dataset.compare || '';
      if (save) {
        if (radio.dataset.save) { save.textContent = 'Save ' + radio.dataset.save + '%'; save.style.display = ''; }
        else { save.style.display = 'none'; }
      }
    });
  });
  var main = document.getElementById('MainImage');
  document.querySelectorAll('.thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (main) { main.removeAttribute('srcset'); main.src = thumb.dataset.src; }
      document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });
});
